import { render } from "./SouConsumidor.vue?vue&type=template&id=4afca312&scoped=true"
import script from "./SouConsumidor.vue?vue&type=script&lang=js"
export * from "./SouConsumidor.vue?vue&type=script&lang=js"

import "./SouConsumidor.vue?vue&type=style&index=0&id=4afca312&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afca312"]])

export default __exports__